import React from 'react';

export default () => {
    return (
        <svg viewBox="0 0 800 90" width="100%" height="100%" fill="currentColor" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" preserveAspectRatio="none">
            <path d="M800 39.58L800 90L0 90L0 28.72C6.43 27.18 10.44 26.21 12.05 25.82C84.18 8.46 159.05 5.66 232.27 17.58C269.39 23.62 281.78 25.64 321.89 32.17C385.24 42.48 450.01 40.23 512.5 25.54C541.15 18.8 540.76 18.9 571.49 11.67C626.6 -1.28 684.23 1.27 737.98 19.06C746.25 21.79 766.92 28.63 800 39.58Z" />
        </svg>
    )
}